/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TenantDialog extends NoboxEntityDialog<TenantRow, any> {
        protected getFormKey() { return TenantForm.formKey; }
        protected getIdProperty() { return TenantRow.idProperty; }
        protected getLocalTextPrefix() { return TenantRow.localTextPrefix; }
        protected getNameProperty() { return TenantRow.nameProperty; }
        protected getService() { return TenantService.baseUrl; }
        protected getDeletePermission() { return TenantRow.deletePermission; }
        protected getInsertPermission() { return TenantRow.insertPermission; }
        protected getUpdatePermission() { return TenantRow.updatePermission; }

        protected form = new TenantForm(this.idPrefix);
        private accountGrid: Nobox.TenantAccountGrid;


        constructor(container?: JQuery) {
            super(container);

            this.accountGrid = new Nobox.TenantAccountGrid($('#accountGrid'));
            this.accountGrid.openDialogsAsPanel = true;
            this.form.Db.change(() => {
                var value = this.form.Db.value;
                if (!Q.isEmptyOrNull(value)) {
                    if (value == "5") {
                        Serenity.EditorUtils.setReadOnly(this.form.ConStr, false);
                        Serenity.EditorUtils.setRequired(this.form.ConStr, true);
                    } else {
                        Serenity.EditorUtils.setReadOnly(this.form.ConStr, true);
                        Serenity.EditorUtils.setRequired(this.form.ConStr, false);
                    }
                }
            });
        }

        protected getToolbarButtons() {

            var $this = this;
            var btn = super.getToolbarButtons();
            btn.push({
                icon: "fa-database text-blue",
                cssClass: "btn-db",
                title: "DB Location",
                separator: true,
                onClick: () => {
                    var dlg = new TenantDbDialog();
                    dlg.funUpdate = (item) => {
                        this.updateDB(item);
                        dlg.dialogClose();
                    };
                    dlg.loadEntityAndOpenDialog(this.get_entity());
                }
            });
            btn.push({
                icon: "fa-database text-blue",
                cssClass: "btn-fixdb",
                title: "Fix DB",
                separator: true,
                onClick: () => {
                    Q.confirm("Fix db on this tenant?", () => {
                        Q.serviceCall({
                            blockUI: false,
                            url: "/Services/Administration/Tenant/FixDB",
                            request: {
                                EntityId: $this.entityId,
                                Entity: $this.get_entity()
                            },
                            onSuccess: (res: any) => {
                                if (res.IsError) {
                                    Q.notifyError("Error fix DB Message = " + res.Message);
                                } else {
                                    Q.notifySuccess("Sucess fix DB for tenantid = " + $this.entityId);
                                }
                            }
                        });
                    });
                }
            });
            if (window.location.host == "trial.nobox.ai") {
                btn.push({
                    icon: "fa-database text-blue",
                    cssClass: "btn-movedb",
                    title: "Move to Subscription",
                    separator: true,
                    onClick: () => {
                        var dlg = new TenantMoveSubscriptionDialog();
                        dlg.moveUpdate = (item) => {
                            Q.confirm("Move to Subscription on this tenant?", () => {
                                var entity = $this.get_entity();
                                entity.Server = item.Server;
                                Q.serviceCall({
                                    blockUI: false,
                                    url: "/Services/Administration/Tenant/MoveSubscription",
                                    request: {
                                        EntityId: $this.entityId,
                                        Entity: entity
                                    },
                                    onSuccess: (res: any) => {
                                        dlg.dialogClose();
                                        if (res.IsError) {
                                            Q.notifyError("Error Move to Subscription Message = " + res.Error);
                                        } else {
                                            Q.notifySuccess("Sucess Move to Subscription for tenantid = " + $this.entityId);
                                        }
                                    }
                                });
                            });
                        };
                        dlg.loadEntityAndOpenDialog(this.get_entity());
                    }
                });
            }
            return btn;
        }

        protected updateInterface() {
            super.updateInterface();
            var item = this.get_entity();
            var $this = this;
            Serenity.EditorUtils.setReadOnly(this.form.ConStr, true);
            Serenity.EditorUtils.setRequired(this.form.ConStr, false);
            if (item.Db == 0) {

            } if (item.Db == 1) {

            } else if (item.Db == 2) {

            } else if (item.Db == 3) {

            } else if (item.Db == 4) {

            } else if (item.Db == 5) {
                Serenity.EditorUtils.setRequired(this.form.ConStr, true);
                Serenity.EditorUtils.setReadOnly(this.form.ConStr, false);
            }
            if (this.isNewOrDeleted()) {
                this.element.find(".btn-db").toggle(false);
                this.element.find(".btn-fixdb").toggle(false);
                this.element.find(".btn-movedb").toggle(false);
            }
            this.form.TenantMembers.callbackSave = () => {
                $this.loadById($this.get_entityId());
                var res = {} as Serenity.SaveResponse;
                $this.showSaveSuccessMessage(res);
            }
            if (this.isEditMode()) {
                this.form.TenantMembers.items = this.get_entity().TenantMembers;
                this.form.TenantMembers.maxuser = item.MaxUser;
                this.form.TenantMembers.membership = item.Level == 1 ? "Trial" : item.Level == 2 ? "Basic" : item.Level == 3 ? "Pro" : item.Level == 4 ? "Unlimited" : "Unlimited";
                this.form.TenantMembers.updateButton();
            } else {
                this.form.TenantMembers.items = [];
                this.form.TenantMembers.maxuser = 2;
                this.form.TenantMembers.membership = "Trial";
                this.form.TenantMembers.updateButton();
            }
        }

        protected updateDB(item: TenantRow) {
            var old = this.get_entity();
            if (old.Db == item.Db && item.Db == 5) {
                if (old.ConStr != item.ConStr) {
                    this.form.ConStr.value = item.ConStr;
                    this.applyChangesButton.click();
                }
            } else if (old.Db != item.Db) {
                Serenity.EditorUtils.setValue(this.form.Db, item.Db);
                if (item.Db == 5) {
                    this.form.ConStr.value = item.ConStr;
                }
                this.applyChangesButton.click();
            }
        }

        protected save() {

            if (this.form.IdtryId.value != "") {
                this.form.IdtryNm.value = this.form.IdtryId.text;
            }

            if (this.form.SzId.value != "") {
                this.form.SzNm.value = this.form.SzId.text;
            }

            if (this.form.CtryId.value != "") {
                this.form.Ctry.value = this.form.CtryId.text;
            }

            if (this.form.StatesId.value != "") {
                this.form.States.value = this.form.StatesId.text;
            }

            if (this.form.CityId.value != "") {
                this.form.City.value = this.form.CityId.text;
            }

            super.save();
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }
        selectEditorTab(editor: Serenity.Widget<any>) {
            let tabId = editor.element.closest('.tab-pane').attr('id');

            let tabAnchor = editor.element.closest('.s-PropertyGrid').find(`a[href='#${tabId}']`);

            (tabAnchor as JQuery).toggleClass("disabled");
        }

        loadEntity(entity: TenantRow) {
            super.loadEntity(entity);

            //Serenity.TabsExtensions.setDisabled(this.tabs, 'Leads', this.isNewOrDeleted());
            if (this.isNewOrDeleted()) {
                this.selectEditorTab(this.form.TenantMembers);
                this.selectEditorTab(this.form.AccountsGrid);
                this.selectEditorTab(this.form.TenantIntegration);
                //this.form.GridContainer.element.closest('.category').toggle(false);
            }
            this.accountGrid.tenantId = entity.Id;
        }
    }
}